<script lang="ts">
  import { Button, Form, FormGroup, Image, Input, Label, Row } from 'sveltestrap';
  import { Bio, EmailAddress, Password, Save, Website } from '../../../../utils/Constant/Constant';
  let imgPath:string = "/assets/images/user"
</script>
<Form>
    <Row class="mb-2">
      <div class="profile-title">
        <div class="media">
          <Image class="img-70 rounded-circle" src="{imgPath}/7.jpg" />
          <div class="media-body">
            <h5 class="mb-1 f-20 txt-primary">{'MARK JECNO'}</h5>
            <p class="f-12">{'DESIGNER'}</p>
          </div>
        </div>
      </div>
    </Row>
    <FormGroup>
      <h6 class="form-label">{Bio}</h6>
      <textarea class="form-control" rows="5">
        {'On the other hand, we denounce with righteous indignation'}
      </textarea>
    </FormGroup>
    <FormGroup>
      <Label>{EmailAddress}</Label>
      <Input placeholder="your-email@domain.com" />
    </FormGroup>
    <FormGroup>
      <Label>{Password}</Label>
      <Input type="password" value="password" />
    </FormGroup>
    <FormGroup>
      <Label >{Website}</Label>
      <Input placeholder="http://Uplor .com" />
    </FormGroup>
    <div class="form-footer">
      <Button class="btn-block" color="primary">{Save}</Button>
    </div>
</Form>